<template>
  <v-app>
    <v-navigation-drawer fixed app v-model="sideNav" class="hidden-md-and-up">
      <v-list>
        <v-list-tile :to="'home'">
          <v-list-tile-action>
            <v-icon left>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Home</v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="item in menuItems"
          v-if="isRequired(item.req)"
          :key="item.title"
          :to="item.link"
        >
          <v-list-tile-action>
            <v-icon left>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="userIsAuthenticated" @click="onLogout">
          <v-list-tile-action>
            <v-icon left>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Logout</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="!userIsAuthenticated">
          <v-list-tile-action>
            <v-icon left>login</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>Login</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar light class="toolbar" v-if="showMenu && !isPlayZone">
      <v-toolbar-side-icon @click="sideNav = ! sideNav" class="hidden-md-and-up"></v-toolbar-side-icon>

      <v-toolbar-title class="titleBar">
        <router-link to="/" tag="span" style="cursor:pointer">
          <img src="./assets/Logo.png" width="80px" />&nbsp;
          <div class="navTitle" :to="'/'">
            A Digital
            <br />Art Platform
            <br />for Hobart
          </div>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          flat
          v-for="item in menuItems"
          v-if="isRequired(item.req)"
          :key="item.title"
          :to="item.link"
        >
          <v-icon v-if="item.icon">&nbsp;{{ item.icon }}</v-icon>
          <span>{{ item.title }}</span>
        </v-btn>
       
        <v-btn 
        v-if="!userIsAuthenticated"
          class="hidden-sm-and-down"
          flat
          to="/signin"
        >
          <v-icon left>login</v-icon>
          <span>Login</span>
        </v-btn>
        <v-spacer></v-spacer>
        
      </v-toolbar-items>
      <v-toolbar-items class="hidden-md-and-up">
        <v-tooltip bottom v-for="item in menuItems" v-if="isRequired(item.req)">
          <v-btn flat slot="activator" :key="item.title" :to="item.link">
            <v-icon left>{{ item.icon }}</v-icon>
            <span class="hidden-sm-and-down">{{ item.title }}</span>
          </v-btn>
          <span>{{ item.title }}</span>
        
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>

    <main>
      <router-view ref="home"></router-view>
    </main>
  </v-app>
</template>
 
<script>

  

export default {
  data() {
    return {
      sideNav: false,
      prelaunch: false
    };
  },
  computed: {
    showMenu() {
      console.log(this.$route.name);
      return !(this.$route.name == "HomePH");
    },
    isPlayZone() {
      var isPlay = false;
      isPlay =
        this.$route.path.indexOf("/launch") > -1 ||
        this.$route.path.indexOf("/play/") > -1 ||
        this.$route.path.indexOf("/colour") > -1 ||
        this.$route.path.indexOf("/pixel") > -1;

      return isPlay;
    },
    menuItems() {
      let menuItems = [
        //{icon: 'face', title: 'Sign Up', link: '/signup'},
        //{icon: 'lock_open', title: 'Sign In', link: '/signin'},

        { title: "Program", link: "/program" },
        { title: "About the Loop", link: "/about" },
        { title: "Participate", link: "/participate" },
       // { title: "Opportunities", link: "/opportunities" },
       // { title: "Events", link: "/events" },
        { title: "Contact", link: "/contact" }
      ];
      console.log(this.$route);
      if (this.$route.name == "Home" && false ){
        menuItems = [
          {icon: 'face', title: 'Sign Up', link: '/signup'},
          {icon: 'lock_open', title: 'Sign In', link: '/signin'},
        ];
      } else if (this.$route.name == "Involved") {
        menuItems.push({ icon: "face", title: "Sign Up", link: "/signup" });
        menuItems.push({
          icon: "lock_open",
          title: "Sign In",
          link: "/signin"
        });
        //{icon: 'movie', title: 'Get involved', link: '/content/new'}
      }
      if (this.userIsAuthenticated) {
        menuItems.push({
          icon: "movie",
          title: "Content",
          link: "/content",
          req: "isCurator"
        });
        menuItems.push({
          icon: "person",
          title: "Profile",
          link: "/profile"
        });
        //menuItems.push({icon: 'filter_frames', title: 'Upload Content', link: '/content/new',req:"notCurator"})
        menuItems.push({
          icon: "filter_frames",
          title: "Upload",
          link: "/content/new",
          req: "isCurator"
        });
        menuItems.push({
          icon: "playlist_play",
          title: "Playlist",
          link: "/playlist",
          req: "isCurator"
        });
        menuItems.push({
          icon: "calendar_today",
          title: "Schedule",
          link: "/schedule",
          req: "isCurator"
        });
        menuItems.push({
          icon: "dashboard",
          title: "vMix",
          link: "/controls",
          req: "isAdmin"
        });
        //menuItems.push({icon: 'person', title: 'Profile', link: '/profile'})
      }
      return menuItems;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    }
  },
  methods: {
    isRequired(req) {
      if (req) {
        switch (req) {
          case "isAdmin":
            return this.$store.getters.userAdmin;
            break;
          case "isCurator":
            return this.$store.getters.userCurator;
          case "notCurator":
            return !this.$store.getters.userCurator;
            break;
        }
      }
      return true;
    },
    onLogout() {
      this.prelaunch = false;
      console.log(this.$refs);
      this.$refs.home.prelaunch = false;
      this.$store.dispatch("logout");
    },
    
  }
};
</script>
<style>
.navTitle {
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  font-size: 15px;
  padding-right: 10px;
  line-height: 20px;
  top: -11px;
  position: relative;
}
.toolBar {
  background-color: #fff;
}
.v-toolbar {
  box-shadow: none !important;
}
.v-toolbar__content {
  height: 90px !important;
  background-color: #fff;
}
.v-toolbar__items .v-btn {
  height: 40px !important;
}
.titlePreview {
  width: 100%;
  max-width: 160px;
  max-height: 100px;
  height: 100%;
  background-color: #000;
  color: #fff;
  margin-right: 20px;
  text-align: center;
  position: relative;
}
.titlePreview .pTitle {
  padding-top: 20%;
  font-size: 60%;
}
.titlePreview .pSubtitle {
  font-size: 40%;
}
.titlePreview .pBody {
  padding-top: 5%;
  font-size: 40%;
}
.titlePreview .pFooter {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 5%;
  font-size: 40%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue